import MenuItem from '@mui/material/MenuItem';
import ButtonLoading from 'common/components/Elements/ButtonLoading/ButtonLoading';
import { isCommandResponse, isFileDownloadCommand } from 'core/api/api.typesGuards';
import CommandLinkContent from 'core/components/Elements/Command/CommandLinkContent/CommandLinkContent';
import type { ItemComponentProps} from 'core/components/Elements/DropDown/DropDown';
import { menuItemStyles } from 'core/components/Elements/DropDown/DropDown';
import ItemFileDownload from 'core/components/Elements/DropDown/ItemFileDownload/ItemFileDownload';
import { getCommand } from 'core/redux/actions/command/commandActions';
import type { ApplicationState } from 'core/redux/reducers/rootReducer';
import type { AppThunkDispatch } from 'core/redux/store/configureStore.types';
import type { EnhancedCommand } from 'core/utilities/core.types';
import type React from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

function ItemGet({
  item, buttonRef, onClose, selected,
}: ItemComponentProps) {
  const {
    id, title, active,
  } = item;
  const dispatch = useDispatch<AppThunkDispatch>();
  const persistingCommand = useSelector((state: ApplicationState) => state.page.persistingCommand);
  const persisting = persistingCommand && persistingCommand.id === id;
  const [downloadCommand, setDownloadCommand] = useState<{
    command: EnhancedCommand; event: React.MouseEvent<HTMLElement>;
  } | undefined>();

  if (downloadCommand) {
    return (
      <ItemFileDownload
        key={downloadCommand.command.id || downloadCommand.command.label}
        item={downloadCommand.command}
        buttonRef={buttonRef}
        onClose={onClose}
        selected={selected}
        autostart={downloadCommand.event}
      />
    );
  }

  return (
    <li role="menuitem" title={title} aria-disabled={active === false}>
      <MenuItem
        component="button"
        role="button"
        data-e2e-dropdown-item={id}
        onClick={async (e: React.MouseEvent<HTMLElement>) => {
          const response = await dispatch(getCommand(item));

          if (isCommandResponse(response) && isFileDownloadCommand(response?.payload)) {
            // Special case where a GET command can return a FileDownload command
            setDownloadCommand({ command: response?.payload, event: e });
          } else {
            onClose(e, buttonRef);
          }
        }}
        dense
        disabled={active === false}
        sx={menuItemStyles}
        selected={selected}
      >
        <CommandLinkContent command={item} />
      </MenuItem>
      {persisting && (
        <ButtonLoading />
      )}
    </li>
  );
}

export default ItemGet;
